export const SearchConf = {
  query: {
    keys: [
      {
        key: 'email',
        operator: '$containsi',
      },

      {
        key: 'surname',
        operator: '$containsi',
      },
      {
        key: 'name',
        operator: '$containsi',
      },
    ],
  },
  placeholder: 'Search by email, name or surname',
  initialState: {
    value: '',
  },
};
